import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Avatar,
  Badge,
  Button,
  Container,
  Grid,
  useMediaQuery
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead'
import Divider from '@mui/material/Divider'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import LockResetIcon from '@mui/icons-material/LockReset'
import RedeemIcon from '@mui/icons-material/Redeem'
import AppIcon from './AppIcon'
import { showToast } from '../utils/AppHelper'
import { TextBold, TextHover, TextRegular, TextSemiBold } from './TextStyling'
import { logoutUser } from '../actions/loginActions'
import { useDispatch } from 'react-redux'
import appassets from '../utils/appassets'
import { paddingHorizontal } from '../utils/AppConstants'
import NotificationsIcon from './NotificationsIcon'
import QuizIcon from '@mui/icons-material/Quiz'
import { ENV } from '../ENV'

export default function HeaderRecruiter ({ user }) {
  const theme = useTheme()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens

  const [openMenu, setOpenMenu] = useState(false)
  const [passwordModal, setPasswordModal] = useState({ open: false })

  const handleMouseLeave = () => {
    setOpenMenu(false)
  }

  const [headerItems, setHeaderItems] = useState([
    {
      label: 'Summary board',
      nav: '/recruiter/dashboard'
    },
    {
      label: 'Monitor candidate',
      nav: '/recruiter/trackcandidate'
    },
    {
      label: 'Jobs',
      menuId: 1,
      open: false,
      menu: [
        {
          label: 'Search job',
          nav: '/recruiter/newsearch'
        },
        { label: 'Jobs in you worklists', nav: '/recruiter/worklist' },
        { label: 'Assignments you handled', nav: '/recruiter/workedon' }
      ]
    },
    {
      label: 'Referral income',
      nav: '/recruiter/referralearning'
    }
  ])

  return (
    <AppBar
      sx={{
        bgcolor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.border.main}`
      }}
      elevation={0}
    >
      <Toolbar
        style={{
          height: matches ? '4rem' : '60px',
          paddingLeft: matches ? '16px' : paddingHorizontal,
          paddingRight: matches ? '16px' : paddingHorizontal
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <AppIcon style={{ width: matches ? '80px' : 80 }} />
        </div>

        <div style={{ display: 'flex' }}>
          {!matches && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                alignItems: 'center',
                flexGrow: 1,
                marginRight: 16
              }}
            >
              {headerItems.map((item, index) => (
                <div key={index}>
                  {item.menu ? (
                    <>
                      <Button
                        id={item.menuId}
                        style={{
                          padding: '10px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          textTransform: 'capitalize'
                        }}
                        onClick={() => {
                          const items = [...headerItems]
                          items[index].open = true
                          setHeaderItems(items)
                        }}
                        aria-controls={item.open ? item.menuId : undefined}
                        aria-haspopup='true'
                        aria-expanded={item.open ? true : undefined}
                      >
                        <TextSemiBold style={{ fontSize: '15px' }}>
                          <TextHover style={{ display: 'flex' }}>
                            {item.label}
                            <KeyboardArrowDownIcon />
                          </TextHover>
                        </TextSemiBold>
                      </Button>
                      <Menu
                        id={item.menuId}
                        anchorE2={item.anchor}
                        open={item.open}
                        onClose={() => {
                          const items = [...headerItems]
                          items[index].open = false
                          setHeaderItems(items)
                        }}
                        anchorPosition={{
                          vertical: 'top',
                          horizontal: 'center'
                        }}
                        anchorEl={document.getElementById(item.menuId)}
                        slotProps={{
                          paper: {
                            elevation: 0,
                            sx: {
                              overflow: 'hidden',
                              filter:
                                'drop-shadow(0px 4px 8px rgba(0,0,0,0.1))',
                              mt: 7.5,
                              borderRadius: '0px',
                              top: '50px !important',
                              '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1
                              },
                              '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0
                              }
                            }
                          }
                        }}
                      >
                        {item?.menu?.map((item, i) => (
                          <>
                            {i === 0 && (
                              <Box
                                style={{
                                  width: '100%',
                                  height: '4px',
                                  background: theme.palette.primary.main,
                                  padding: '0px',
                                  marginTop: '-8px'
                                }}
                              />
                            )}
                            <MenuItem
                              style={{
                                fontSize: 14,
                                fontWeight: 500,
                                lineHeight: '2rem'
                              }}
                              onClick={() => {
                                const items = [...headerItems]
                                items[index].open = false
                                setHeaderItems(items)
                                if (item.nav) {
                                  navigate(item.nav)
                                }
                              }}
                            >
                              <TextHover>{item.label}</TextHover>
                            </MenuItem>
                          </>
                        ))}
                      </Menu>
                    </>
                  ) : (
                    <TextSemiBold
                      style={{
                        padding: '10px',
                        cursor: 'pointer',
                        fontSize: '15px'
                      }}
                      onClick={() => navigate(item.nav)}
                    >
                      <TextHover>{item.label}</TextHover>
                    </TextSemiBold>
                  )}
                </div>
              ))}
            </div>
          )}

          <NotificationsIcon usertype={user.usertype} />

          {/* Profile div */}
          <div
            onClick={() => {
              setOpenMenu(true)
            }}
            style={{
              display: 'flex',
              cursor: 'pointer',
              alignItems: 'center'
            }}
            aria-controls={openMenu ? 'account-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={openMenu ? 'true' : undefined}
          >
            <Avatar
              sx={{
                width: '32px',
                height: '32px',
                marginRight: matches ? '0px' : '6px' // Adjust margin for small screens
              }}
            />

            {!matches && (
              <TextSemiBold
                style={{
                  fontSize: '15px',
                  textTransform: 'capitalize'
                }}
              >
                <TextHover>
                  {user?.firstname} {user?.lastname}
                </TextHover>
              </TextSemiBold>
            )}
          </div>

          <Menu
            id='account-menu'
            open={openMenu}
            onClose={handleMouseLeave}
            slotProps={{
              paper: {
                elevation: 0,
                sx: {
                  overflow: 'hidden',
                  filter: 'drop-shadow(0px 4px 8px rgba(0,0,0,0.1))',
                  mt: matches ? 3 : 9.8,
                  borderRadius: '0px',
                  transform: 'translateY(16px) !important',
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1
                  },
                  '&::before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0
                  }
                }
              }
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          >
            {[
              {
                label: 'Edit Profile',
                icon: <img src={`${appassets.edit}`} alt='edit' />,
                nav: '/recruiter/editprofile'
              },
              {
                label: 'Update your phone number',
                icon: <img src={`${appassets.call}`} alt='edit' />,
                nav: '/recruiter/editprofile',
                state: 'phone'
              },
              {
                label: 'Edit Preferences',
                icon: (
                  <MarkEmailReadIcon
                    style={{ margin: -4, color: theme.palette.text.secondary }}
                  />
                ),
                nav: '/recruiter/editpreferences'
              },
              {
                label: 'Contact us',
                icon: <img src={appassets.help} alt='help' />,
                type: ENV.contact_us
              },
              {
                label: 'Change password',
                icon: (
                  <LockResetIcon
                    style={{ margin: -4, color: theme.palette.text.secondary }}
                  />
                ),
                nav: '/recruiter/changepassword'
              },
              {
                label: 'FAQ',
                icon: <QuizIcon fontSize='small' />,
                type: '/faq'
              },
              {
                label: 'Logout',
                icon: <img src={appassets.logout} alt='logout' />,
                type: 'logout'
              }
            ].map((item, index) => (
              <>
                {index === 0 && (
                  <Box
                    style={{
                      width: '100%',
                      height: '4px',
                      background: theme.palette.primary.main,
                      padding: '0px',
                      marginTop: '-7px'
                    }}
                  />
                )}
                <MenuItem
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    handleMouseLeave()

                    if (item.type) {
                      if (item.type === 'logout') {
                        dispatch(logoutUser(navigate, true))
                      } else {
                        window.open(item.type, '__blank')
                      }
                    } else {
                      navigate(item.nav, { state: item.state })
                    }
                  }}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <TextSemiBold style={{ fontSize: '15px' }}>
                    <TextHover>{item.label}</TextHover>
                  </TextSemiBold>
                </MenuItem>
              </>
            ))}
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  )
}
